/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TotalIncomeDto as DigiworkMaitreDPosDtoBillsTotalIncomeDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Bills/total-income-dto';

export interface GetTotalIncome$Params {
  venueId: string;
  dateFrom?: string;
  dateTo?: string;
}

export function getTotalIncome(http: HttpClient, rootUrl: string, params: GetTotalIncome$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsTotalIncomeDto>> {
  const rb = new RequestBuilder(rootUrl, getTotalIncome.PATH, 'get');
  if (params) {
    rb.path('venueId', params.venueId, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoBillsTotalIncomeDto>;
    })
  );
}

getTotalIncome.PATH = '/api/dashboard/{venueId}/total-income';
